<template>
  <vue-nestable
    class="hierarchy"
    :value="value || (showRoot ? [{ title:'root', uri:'', id:0, depth:0, children:articleHierarchy }] : articleHierarchy)"
  >
    <span
      class="hierarchy-entry"
      :class="{
        clickable: clickable,
        hidden: hiddenUri.length > 0 ? item.uri == hiddenUri : false,
      }"
      v-show="relativeFilter(item)"
      slot-scope="{ item }"
      @click="(clickable && selectedUri !== item.uri) ? $emit('uriClick', item.uri) : ()=>{}"
    >
      <span class="text-body-2">{{ getMarker(item, articleHierarchy) }} </span>
      <span class="hierarchy-item" :class="{
        selected: selectedUri === item.uri,
      }">{{ item.title + ((editMode && item.uri === editOrigLocation) ? ' ← Current article location' : '') }}</span>
    </span>
  </vue-nestable>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    value: {
      type: Array,
      required: false
    },
    disableRelativeFilter: {
      type: Number,
      default: 1
    },
    childrenDepth: {
      type: Number,
      default: 2 // some articles have grandparents, but nonexistent parents (as of 2/4/2021)
    },
    parentHeight: {
      type: Number,
      default: 3 // some articles only have greatgrandparents (as of 2/4/2021)
    },
    selectedUri: {
      type: String,
      default: ''
    },
    hiddenUri: {
      type: String,
      default: ''
    },
    editMode: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    },
    showRoot: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editOrigLocation: this.editMode ? this.$route.params.pathMatch.split('/').slice(0, -1).join('/') : ''
    }
  },
  methods: {
    relativeFilter (item) {
      const selectedsPathArr = this.selectedUri.split('/')
      const selectedsDepth = selectedsPathArr.length
      const selectedsParentUri = selectedsPathArr.slice(0, -1).join('/')
      return (!this.disableRelativeFilter || // if filter enabled
        ( // always show home uri
          item.uri === process.env.VUE_APP_HOME_URI
        ) ||
        ( // always show root level items
          item.depth === 1
        ) ||
        ( // parents
          selectedsDepth - this.parentHeight <= item.depth && item.depth < selectedsDepth &&
          item.uri === selectedsPathArr.slice(0, item.depth).join('/')
        ) ||
        ( // peers
          item.uri.startsWith(selectedsParentUri + '/') && item.depth === selectedsDepth
        ) ||
        ( // children
          item.depth <= selectedsDepth + this.childrenDepth &&
          item.uri.startsWith(this.selectedUri + '/')
        )
      )
    },
    hasChildren (checkItem, articleHierarchy) {
      return articleHierarchy.find(item => {
        if (item.uri.startsWith(checkItem.uri + '/')) {
          return true // Found a child, exit find successfully
        } else {
          if (typeof item.children !== 'undefined' && checkItem.uri.startsWith(item.uri)) {
            if (this.hasChildren(checkItem, item.children)) {
              return true // Found a child, exit find successfully
            }
          }
        }
        return false // Haven't found children, keep looking if we can
      })
    },
    getMarker (item, articleHierarchy) {
      const selectedsPathArr = this.selectedUri.split('/')
      const selectedsDepth = selectedsPathArr.length
      if (!this.hasChildren(item, articleHierarchy)) { // Item has no children
        return '•'
      }
      if (this.selectedUri.startsWith(item.uri + '/') || // Ancestor of selected item, or
          this.selectedUri === item.uri || // Current item with descendants, or
          (item.uri.startsWith(this.selectedUri + '/') && item.depth <= selectedsDepth + this.childrenDepth - 1 && item.depth > selectedsDepth) // Descendant of current item with visible children
      ) {
        return '▼'
      }
      return '►'
    }
  },
  computed: {
    ...mapState('article', {
      articleHierarchy: state => state.articleHierarchy
    })
  }
}
</script>

<style>
.hierarchy ol li {
  list-style-type: none;
}
.hierarchy-entry {
  display: inline-flex;
}
.hierarchy-item {
  padding-left: .2rem;
}
.clickable {
  cursor: pointer;
}
.selected {
  font-weight: bold !important;
  font-size: 1.05rem;
  text-decoration: underline;
  cursor: default !important;
}
.hidden {
  display: none;
}
</style>
